import React from "react";
import { ChevronRightRounded, LogoutRounded } from "@mui/icons-material";
import { fdcNavigation } from "./fdcNavigation";

export default function FDCSidebar({ page, onNavigate, user, onLogout, unread, messagesUnread }) {
  return (
    <aside className="fdcSidebar">
      <div className="fdcBrand">
        <div className="fdcBrandMark">U</div>
        <div><strong>Universe</strong><span>Business Development</span></div>
      </div>

      <nav className="fdcNav" aria-label="FDC workspace">
        {fdcNavigation.map(group => (
          <div className="fdcNavGroup" key={group.group}>
            <p className="fdcNavGroupLabel">{group.group}</p>
            {group.items.map(item => {
              const Icon = item.icon;
              const badge=item.page==="notifications"?unread:item.page==="messages"?messagesUnread:0;
              const active = page === item.page;
              return (
                <button key={item.page} className={`fdcNavItem ${active ? "active" : ""}`}
                  onClick={() => onNavigate(item.page)}>
                  <span className="fdcNavItemMain">
                    <Icon className="fdcNavIcon" />
                    <span>{item.label}</span>
                  </span>
                  {badge ? <span className="fdcNavBadge">{badge}</span> :
                    active ? <ChevronRightRounded className="fdcNavArrow" /> : null}
                </button>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="fdcSidebarProfile">
        <div className="fdcAvatar">{user.initials}</div>
        <div className="fdcSidebarProfileText">
          <strong>{user.firstName} {user.lastName}</strong>
          <span>{user.level} • {user.state}</span>
        </div>
        <button className="fdcIconButton fdcLogout" aria-label="Log out" onClick={onLogout}><LogoutRounded /></button>
      </div>
    </aside>
  );
}
